import BottomCart from './BottomCart.view';

export default BottomCart;
